// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventoryReport_wrapper__zR6Qg {
  width: 100%;
  height: calc(100vh - 110px);
  padding: 0px 10px 27px 10px;
  overflow: auto;
  position: relative; }
  .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl {
    color: var(--HightEmphasis);
    position: sticky;
    display: flex;
    align-items: center;
    justify-content: space-between;
    top: 0;
    left: 0;
    background-color: #ffffff;
    padding: 10px 0 0 0;
    z-index: 100; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl .inventoryReport_title__73bVR {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.03em; }
      .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl .inventoryReport_title_left__Qwpa3 {
        display: flex;
        align-items: center; }
        .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl .inventoryReport_title_left__Qwpa3 .inventoryReport_search__rvFT1 {
          width: 260px;
          padding: 5px;
          border: none;
          border-bottom: 1px solid #9e9e9e;
          outline: none; }
          .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl .inventoryReport_title_left__Qwpa3 .inventoryReport_search__rvFT1::after {
            content: 'sdf'; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_header__RmOTl .inventoryReport_date__g8EL0 {
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      margin-left: 8px;
      color: #9e9e9e; }
  .inventoryReport_wrapper__zR6Qg table {
    width: 100%;
    background: white; }
  .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul {
    margin-top: 20px; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_emptyList__f9MoD {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--HightEmphasis);
      letter-spacing: 0.15px;
      margin-top: 20px; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_statusTh__t5S-3 {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 20%; }
      .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_statusTh__t5S-3 .inventoryReport_arrowUp__TsqpD {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid var(--LowEmphasis);
        margin-left: 7px; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_sortOn__Gn74s {
      margin: 0 0 1px 5px;
      transform: rotateX(180deg); }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_sortOff__mwVBU {
      margin: 0 0 1px 5px;
      transform: rotateX(0deg); }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_disableSort__L78WU {
      pointer-events: none; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul th {
      text-align: left;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.1px;
      color: var(--LowEmphasis); }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_editIcon__KoD3S {
      cursor: pointer; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_status__mz3Ri {
      letter-spacing: 0.1px;
      color: var(--White);
      border-radius: 20px;
      padding: 4px 10px;
      font-weight: 400;
      font-size: 12px;
      line-height: 24px; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_multi__oBtb5 {
      padding: 2px 4px;
      align-items: center;
      color: #296483;
      font-weight: 600;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      background-color: #d1e3e4;
      margin-left: 5px;
      border-radius: 5px;
      line-height: 150%; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_bottle__TthhK {
      padding: 2px 4px;
      align-items: center;
      color: #509296;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      background-color: #d1e3e4;
      margin-left: 5px;
      border-radius: 5px;
      line-height: 150%; }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_statusStock__LHpmk {
      background: var(--Green); }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_statusLowStock__9D\\+7t {
      background: var(--StockOrange); }
    .inventoryReport_wrapper__zR6Qg .inventoryReport_content__mtqul .inventoryReport_statusOutStock__Po1UL {
      background: var(--StockRed); }

.inventoryReport_tableHeader__GwkQv {
  width: 100%;
  background: white; }

.inventoryReport_item__Z98e8 {
  width: 22%; }

.inventoryReport_stock__hx5NU,
.inventoryReport_low__Id9o9 {
  width: 14%; }

.inventoryReport_camera__AUrCz {
  width: 18%; }

.inventoryReport_status__mz3Ri {
  width: 18%; }

.inventoryReport_settings__NTaxy {
  width: 7%; }

.inventoryReport_show__D2OSm {
  width: 5%;
  cursor: pointer; }
  .inventoryReport_show__D2OSm .inventoryReport_top__nSNVr {
    transform: rotate(180deg); }

.inventoryReport_history__L3WBQ {
  width: 100%; }

thead th {
  position: sticky;
  top: 37px;
  background: white;
  z-index: 100;
  border-collapse: collapse; }

tbody td {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: var(--HightEmphasis);
  padding: 5px 0; }

.inventoryReport_itemLine__koirl {
  cursor: pointer;
  background-color: white;
  transition: all 0.4s; }
  .inventoryReport_itemLine__koirl:hover {
    background: rgba(254, 97, 0, 0.1); }

.inventoryReport_cameraTD__H9SF7 {
  position: relative; }

.inventoryReport_glazik__fNy-H {
  position: absolute;
  top: calc(50% - 8px);
  color: #666666;
  cursor: pointer;
  height: 14px;
  width: 14px; }
  .inventoryReport_glazik__fNy-H:hover {
    color: black; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/InventoryReport/inventoryReport.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,kBAAkB,EAAA;EALpB;IAOI,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,mBAAmB;IACnB,YAAY,EAAA;IAhBhB;MCUE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDOb,sBAAsB,EAAA;MAnB5B;QAqBQ,aAAa;QACb,mBAAmB,EAAA;QAtB3B;UAwBU,YAAY;UACZ,YAAY;UACZ,YAAY;UACZ,gCAAgC;UAChC,aAAa,EAAA;UA5BvB;YA8BY,cAAc,EAAA;IA9B1B;MAqCM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,cAAc,EAAA;EAzCpB;IA6CI,WAAW;IACX,iBAAiB,EAAA;EA9CrB;IAiDI,gBAAgB,EAAA;IAjDpB;MCkCE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDiBb,2BAA2B;MAC3B,sBAAsB;MACtB,gBAAgB,EAAA;IAvDtB;MA2DM,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,UAAU,EAAA;MA9DhB;QAgEQ,QAAQ;QACR,SAAS;QACT,kCAAkC;QAClC,mCAAmC;QACnC,2CAA2C;QAC3C,gBAAgB,EAAA;IArExB;MAyEM,mBAAmB;MACnB,0BAA0B,EAAA;IA1EhC;MA8EM,mBAAmB;MACnB,wBAAwB,EAAA;IA/E9B;MAkFM,oBAAoB,EAAA;IAlF1B;MAsFM,gBAAgB;MC9CpB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MD8Cb,qBAAqB;MACrB,yBAAyB,EAAA;IAzF/B;MA6FM,eAAe,EAAA;IA7FrB;MAiGM,qBAAqB;MACrB,mBAAmB;MACnB,mBAAmB;MACnB,iBAAiB;MCpCrB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IDlEnB;MAwGM,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;MACzB,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB,EAAA;IAlHvB;MAsHM,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;MACzB,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB,EAAA;IA/HvB;MAkIM,wBAAwB,EAAA;IAlI9B;MAsIM,8BAA8B,EAAA;IAtIpC;MA0IM,2BAA2B,EAAA;;AAIjC;EACE,WAAW;EACX,iBAAiB,EAAA;;AAEnB;EACE,UAAU,EAAA;;AAEZ;;EAEE,UAAU,EAAA;;AAEZ;EACE,UAAU,EAAA;;AAEZ;EACE,UAAU,EAAA;;AAEZ;EACE,SAAS,EAAA;;AAEX;EACE,SAAS;EACT,eAAe,EAAA;EAFjB;IAII,yBAAyB,EAAA;;AAG7B;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,yBAAyB,EAAA;;AAG3B;EC7IE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;ED6IjB,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,uBAAuB;EACvB,oBAAoB,EAAA;EAHtB;IAMI,iCAAiC,EAAA;;AAGrC;EACE,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW,EAAA;EANb;IAQI,YAAY,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.wrapper {\n  width: 100%;\n  height: calc(100vh - 110px);\n  padding: 0px 10px 27px 10px;\n  overflow: auto;\n  position: relative;\n  .header {\n    color: var(--HightEmphasis);\n    position: sticky;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    top: 0;\n    left: 0;\n    background-color: #ffffff;\n    padding: 10px 0 0 0;\n    z-index: 100;\n    .title {\n      @include h3;\n      letter-spacing: 0.03em;\n      &_left {\n        display: flex;\n        align-items: center;\n        .search {\n          width: 260px;\n          padding: 5px;\n          border: none;\n          border-bottom: 1px solid #9e9e9e;\n          outline: none;\n          &::after {\n            content: 'sdf';\n          }\n        }\n      }\n    }\n\n    .date {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 150%;\n      margin-left: 8px;\n      color: #9e9e9e;\n    }\n  }\n  table {\n    width: 100%;\n    background: white;\n  }\n  .content {\n    margin-top: 20px;\n\n    .emptyList {\n      @include body1;\n      color: var(--HightEmphasis);\n      letter-spacing: 0.15px;\n      margin-top: 20px;\n    }\n\n    .statusTh {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      width: 20%;\n      .arrowUp {\n        width: 0;\n        height: 0;\n        border-left: 5px solid transparent;\n        border-right: 5px solid transparent;\n        border-bottom: 5px solid var(--LowEmphasis);\n        margin-left: 7px;\n      }\n    }\n    .sortOn {\n      margin: 0 0 1px 5px;\n      transform: rotateX(180deg);\n    }\n\n    .sortOff {\n      margin: 0 0 1px 5px;\n      transform: rotateX(0deg);\n    }\n    .disableSort {\n      pointer-events: none;\n    }\n\n    th {\n      text-align: left;\n      @include body2;\n      letter-spacing: 0.1px;\n      color: var(--LowEmphasis);\n    }\n\n    .editIcon {\n      cursor: pointer;\n    }\n\n    .status {\n      letter-spacing: 0.1px;\n      color: var(--White);\n      border-radius: 20px;\n      padding: 4px 10px;\n      @include caption;\n    }\n    .multi {\n      padding: 2px 4px;\n      align-items: center;\n      color: #296483;\n      font-weight: 600;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      background-color: #d1e3e4;\n      margin-left: 5px;\n      border-radius: 5px;\n      line-height: 150%;\n\n    }\n    .bottle{\n      padding: 2px 4px;\n      align-items: center;\n      color: #509296;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      background-color: #d1e3e4;\n      margin-left: 5px;\n      border-radius: 5px;\n      line-height: 150%;\n    }\n    .statusStock {\n      background: var(--Green);\n    }\n\n    .statusLowStock {\n      background: var(--StockOrange);\n    }\n\n    .statusOutStock {\n      background: var(--StockRed);\n    }\n  }\n}\n.tableHeader {\n  width: 100%;\n  background: white;\n}\n.item {\n  width: 22%;\n}\n.stock,\n.low {\n  width: 14%;\n}\n.camera {\n  width: 18%;\n}\n.status {\n  width: 18%;\n}\n.settings {\n  width: 7%;\n}\n.show {\n  width: 5%;\n  cursor: pointer;\n  .top {\n    transform: rotate(180deg);\n  }\n}\n.history {\n  width: 100%;\n}\n\nthead th {\n  position: sticky;\n  top: 37px;\n  background: white;\n  z-index: 100;\n  border-collapse: collapse;\n}\n\ntbody td {\n  @include body2;\n  letter-spacing: 0.1px;\n  color: var(--HightEmphasis);\n  padding: 5px 0;\n}\n\n.itemLine {\n  cursor: pointer;\n  background-color: white;\n  transition: all 0.4s;\n\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n  }\n}\n.cameraTD {\n  position: relative;\n}\n.glazik {\n  position: absolute;\n  top: calc(50% - 8px);\n  color: #666666;\n  cursor: pointer;\n  height: 14px;\n  width: 14px;\n  &:hover {\n    color: black;\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `inventoryReport_wrapper__zR6Qg`,
	"header": `inventoryReport_header__RmOTl`,
	"title": `inventoryReport_title__73bVR`,
	"title_left": `inventoryReport_title_left__Qwpa3`,
	"search": `inventoryReport_search__rvFT1`,
	"date": `inventoryReport_date__g8EL0`,
	"content": `inventoryReport_content__mtqul`,
	"emptyList": `inventoryReport_emptyList__f9MoD`,
	"statusTh": `inventoryReport_statusTh__t5S-3`,
	"arrowUp": `inventoryReport_arrowUp__TsqpD`,
	"sortOn": `inventoryReport_sortOn__Gn74s`,
	"sortOff": `inventoryReport_sortOff__mwVBU`,
	"disableSort": `inventoryReport_disableSort__L78WU`,
	"editIcon": `inventoryReport_editIcon__KoD3S`,
	"status": `inventoryReport_status__mz3Ri`,
	"multi": `inventoryReport_multi__oBtb5`,
	"bottle": `inventoryReport_bottle__TthhK`,
	"statusStock": `inventoryReport_statusStock__LHpmk`,
	"statusLowStock": `inventoryReport_statusLowStock__9D+7t`,
	"statusOutStock": `inventoryReport_statusOutStock__Po1UL`,
	"tableHeader": `inventoryReport_tableHeader__GwkQv`,
	"item": `inventoryReport_item__Z98e8`,
	"stock": `inventoryReport_stock__hx5NU`,
	"low": `inventoryReport_low__Id9o9`,
	"camera": `inventoryReport_camera__AUrCz`,
	"settings": `inventoryReport_settings__NTaxy`,
	"show": `inventoryReport_show__D2OSm`,
	"top": `inventoryReport_top__nSNVr`,
	"history": `inventoryReport_history__L3WBQ`,
	"itemLine": `inventoryReport_itemLine__koirl`,
	"cameraTD": `inventoryReport_cameraTD__H9SF7`,
	"glazik": `inventoryReport_glazik__fNy-H`
};
export default ___CSS_LOADER_EXPORT___;
